
import React, {useEffect, useState} from 'react';


function App() {  
  const [wellcome, setWellcome] = useState(); 
         useEffect(() => {
            let url = "./configs/wellcome.json";
            fetch(url)
                .then(res => res.json())
                .then(json => setWellcome(json))
            }, []);

    return (
      wellcome!=undefined?
      <div className="component-view animate" data-animate="blendin 3s">
          <img className="image-view " src="./images/default.jpg" />          
          
          {/* <div className="text-item text-header">
            {wellcome.header}
          </div>  */}            
              
          
          <div className='text-item text-block '>
          {
              wellcome.content.map(item=>(
                <>            
                  {item}
            
          </>))}

          </div>
        </div>:null
      
     
            );
        }
    
    export default App;